import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, Grid, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import Content from './DocumentContent';
import Notes from '../class/notes/Notes';
import DocumentBar from './DocumentBar';
import KickerWidget from '../kicker/KickerWidget';
import formatSeconds from '../common/formatSeconds';
import { getDocumentData } from '../item/getData';
import NotAuthorizedBanner from '../common/NotAuthorizedBanner';
const DocumentWidget = ({ documentKey, settings: { showNotes, showTranscripts, showKicker, showCTA, showOverview, }, }) => {
    const store = useStore();
    const [notAuthorized, setNotAuthorized] = useState(false);
    const [itemProgress, setItemProgress] = useState({});
    const [currentPosition, setCurrentPosition] = useState(0);
    const [seekPosition, setSeekPosition] = useState(null);
    const [seekTrigger, setSeekTrigger] = useState(null);
    // const [document, setDocument] = useState<IDocument | null>();
    const [kicker, setKicker] = useState();
    const document = documentKey ? store.getOrLoad('document', documentKey) : undefined;
    const { currentPortal } = store;
    const { isAnonymous } = useStore();
    const updateItemProgress = async (progress) => {
        setItemProgress(await store.trackDocumentProgress(document?.key, progress));
    };
    useEffect(() => {
        const startDocument = async () => {
            if (document?.key) {
                // const doc = await store.load('document', document.key);
                // setDocument(doc);
                const progress = await store.startDocument(document);
                if (!progress) {
                    console.log('No access to this document');
                    setNotAuthorized(true);
                }
                else {
                    setNotAuthorized(false);
                }
                setItemProgress(progress);
            }
        };
        startDocument();
    }, [store, document?.key]);
    useEffect(() => {
        if (document?.kicker?.id) {
            setKicker(document?.kicker);
        }
    }, [document?.kicker]);
    const playerContainerRef = React.useRef(null);
    const handleViewNote = (note) => {
        const { reference } = note;
        const courseItemDetails = reference?.split('/') || [];
        setSeekPosition(parseInt(courseItemDetails[3], 10));
        setSeekTrigger(Date.now());
        // @ts-expect-error Fix the type on the ref and this should work
        playerContainerRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };
    if (!documentKey) {
        return _jsx("div", { children: "\u00A0" });
    }
    // it can be an array of id/name pairs
    const makeReference = () => ([
        `${document?.id}/${document?.id}/video/${currentPosition}`,
        `${document?.name}/${document?.name}/Video/${formatSeconds(currentPosition)}`,
    ]);
    if (!document) {
        return _jsx("div", { children: "\u00A0" });
    }
    return (_jsx(Box, { children: _jsxs(Grid, { container: true, children: [_jsx(DocumentBar, { name: document.name }), _jsx(Grid, { item: true, xs: 12, md: 12, order: { xs: 1, md: 0 }, ref: playerContainerRef, children: _jsx(Grid, { item: true, xs: 12, md: 12, order: { xs: 0, md: 1 }, sx: { p: 2 }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, md: 9, children: notAuthorized ? (_jsx(NotAuthorizedBanner, { currentPortal: currentPortal })) : (
                                    // eslint-disable-next-line react/jsx-no-useless-fragment
                                    _jsx(Content, { document: document, 
                                        // itemProgress={itemProgress}
                                        // currentPosition={currentPosition}
                                        setCurrentPosition: setCurrentPosition, seekPosition: seekPosition, seekTrigger: seekTrigger, updateProgress: updateItemProgress, showTranscripts: showTranscripts, showOverview: showOverview, showCTA: showCTA, showMakeANoteBtn: showNotes, showDownloadButton: true })) }), _jsxs(Grid, { item: true, xs: 12, md: 3, children: [showKicker && (_jsx(Box, { sx: { mt: 2 }, children: _jsx(KickerWidget, { kickerID: kicker?.id, limitToPageWidth: true }) })), !isAnonymous && showNotes && (_jsx(Notes, { handleViewNote: handleViewNote, makeReference: makeReference, isCourseItemSelected: !!document?.id, progress: itemProgress, modelName: "documentProgress" }))] })] }) }) })] }) }));
};
DocumentWidget.getData = async ({ documentKey }, store) => {
    console.log('Adding document to preload', documentKey);
    if (!documentKey) {
        console.log('No item to load for DocumentWidget card');
        return 'ok';
    }
    await getDocumentData(store, documentKey);
    return 'ok';
};
DocumentWidget.defaultProps = {
    settings: {
        showNotes: true,
        showTranscripts: true,
        showKicker: true,
        showCTA: true,
        showOverview: true,
    },
};
DocumentWidget.meta = {
    group: 'deliveryPages',
    name: 'Document Delivery Panel',
    description: 'Displays the full document delivery interface.',
    props: [
        {
            key: 'documentKey',
            returnId: true, // hack to to make the picker return the course ID
            name: 'document',
            type: 'document', // note this is a special type recognized by the system
            description: 'The document being delivered.',
        },
        {
            key: 'settings.showTranscripts',
            name: 'Show Transcripts',
            type: 'boolean',
            description: 'Show the intro video on the card',
        },
        {
            key: 'settings.showNotes',
            name: 'Show Notes',
            type: 'boolean',
            description: 'Show the course info on the card',
        },
        {
            key: 'settings.showKicker',
            name: 'Show Kicker',
            type: 'boolean',
            description: 'Show the course headline on the card',
        },
        {
            key: 'settings.showCTA',
            name: 'Show CTA',
            type: 'boolean',
            description: 'Show the course description on the card',
        },
        {
            key: 'settings.showOverview',
            name: 'Show Overview',
            type: 'boolean',
            description: 'Show the order by company name on the card',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'DocumentWidget',
        props: {
            documentKey: '@documentKey',
            settings: {
                showNotes: true,
                showTranscripts: true,
                showKicker: true,
                showCTA: true,
                showOverview: true,
            },
        },
    },
};
export default observer(DocumentWidget);
//# sourceMappingURL=DocumentWidget.js.map